/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import wizardStyle from "../wizardStyle";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import SpeedingIcon from "../../../assets/icons/traffic/toggleable/IconFastDriving";
import RedLightIcon from "../../../assets/icons/traffic/toggleable/IconRedTrafficLight";
import DistanceIcon from "../../../assets/icons/traffic/toggleable/IconDistance";
import OtherIcon from "../../../assets/icons/traffic/toggleable/IconPhoneDrugsParking";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { FormDataTypes } from "../../../types/FormDataTypes";
import { Box } from "@mui/material";

export default function Accusation({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="accusation"
                question={translate("traffic.accusation.label", values)}
                modalContent={
                  <p>
                    Bitte geben Sie an was Ihnen vorgeworfen wird. Diese Informationen finden Sie auf der Anhörung, dem Bußgeldbescheid, dem Strafbefehl oder
                    dem Zeugenfragebogen.
                  </p>
                }
                options={[
                  {
                    labelText: translate("traffic.accusation.options.speeding.label", values),
                    labelIcon: <SpeedingIcon />,
                    labelIconActive: <SpeedingIcon active />,
                    value: "speeding",
                  },
                  {
                    labelText: translate("traffic.accusation.options.red_light.label", values),
                    labelIcon: <RedLightIcon />,
                    labelIconActive: <RedLightIcon active />,
                    value: "red_light",
                  },
                  {
                    labelText: translate("traffic.accusation.options.distance.label", values),
                    labelIcon: <DistanceIcon />,
                    labelIconActive: <DistanceIcon active />,
                    value: "distance",
                  },
                  {
                    labelText: translate("traffic.accusation.options.other.label", values),
                    labelIcon: <OtherIcon />,
                    labelIconActive: <OtherIcon active />,
                    value: "other",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
